// extracted by mini-css-extract-plugin
module.exports = {"noInfoWrap":"noInfoWrap_2zPBo8iI","emptyImg":"emptyImg_3uKsWcjH","message":"message_231IKhbp","btn":"btn_1MvwTzdZ"};